export default __webpack_public_path__ + "static/media/rating_6_reject.454551ff.svg";